import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { QUOTE_QUESTIONS } from "../../AppConstants";

const rules = {
    effectiveDate: 'required'
};

export const allFieldsValidation = (data, stateCode: string | null = null) => {
    if (stateCode && stateCode === "TX") {
        rules["hasInsurance"] = ['required'];
        rules["currentInsuranceCompanyMonths"] = ['required_if:hasInsurance,' + QUOTE_QUESTIONS.YES_NO.YES]
    }
    else {
        delete rules["hasInsurance"];
        delete rules["currentInsuranceCompanyMonths"];
    }

    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};